import { MessageCircle, ChevronRight, AlertTriangle, Info } from "lucide-react";

export const SmartGuidanceBubble = ({ guidance, onDismiss, onClick }) => {
  if (!guidance) return null;
  
  const isRisk = guidance.type === 'risk';
  
  return (
    <div 
      className="absolute z-30 animate-fade-in pointer-events-none"
      style={{ 
        left: guidance.position?.x || '50%',
        top: guidance.position?.y || 0,
        transform: 'translateX(-50%)'
      }}
    >
      <div className="relative">
        {/* Bubble - only this interactive element should capture pointer events */}
        <div 
          onClick={() => onClick ? onClick(guidance) : onDismiss()}
          className={`px-4 py-3 rounded-2xl text-white shadow-xl cursor-pointer hover:scale-105 transition-transform pointer-events-auto ${
            isRisk 
              ? 'bg-gradient-to-r from-red-500 to-red-600 shadow-red-500/30' 
              : 'bg-gradient-to-r from-p2p-teal to-emerald-500 shadow-p2p-teal/30'
          }`}
          data-testid="guidance-bubble"
        >
          <div className="flex items-center gap-2">
            {isRisk ? (
              <AlertTriangle className="w-4 h-4 flex-shrink-0" />
            ) : (
              <Info className="w-4 h-4 flex-shrink-0" />
            )}
            <span className="text-sm font-medium">{guidance.message}</span>
          </div>
          {guidance.cta && (
            <div className="flex items-center justify-center gap-1 mt-2 pt-2 border-t border-white/20">
              <span className="text-xs font-semibold">{guidance.cta}</span>
              <ChevronRight className="w-3 h-3" />
            </div>
          )}
        </div>
        {/* Arrow pointing down - non-interactive */}
        <div className={`absolute left-1/2 -translate-x-1/2 -bottom-2 w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent ${
          isRisk ? 'border-t-red-600' : 'border-t-emerald-500'
        }`} />
      </div>
    </div>
  );
};

export default SmartGuidanceBubble;
